var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mb-4"},[_c('v-card-title',[_vm._v("来店履歴")]),_c('v-card-text',[_c('v-data-table',{attrs:{"options":_vm.tableOptions,"headers":_vm.headers,"items":_vm.visitHistory,"loading":_vm.isLoading,"server-items-length":_vm.totalCount,"footer-props":{
        itemsPerPageText: '行/ページ:',
        itemsPerPageOptions: [10, 25, 50],
      },"no-data-text":"来店履歴がありません","loading-text":"読み込み中..."},on:{"update:options":_vm.handleOptionsUpdate},scopedSlots:_vm._u([{key:"item.visitedAt",fn:function(ref){
      var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatDateTime(item.visitedAt))+" ")]}},{key:"item.customerCount",fn:function(ref){
      var item = ref.item;
return [_vm._v(" "+_vm._s(item.customerCount || 0)+"名 ")]}},{key:"item.paidAmount",fn:function(ref){
      var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatCurrency(item.paidAmount))+" ")]}},{key:"item.total",fn:function(ref){
      var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.formatCurrency(item.total))+" ")]}}],null,true)})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }